import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Table, FormControl } from 'react-bootstrap';
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import { connect } from 'react-redux';

import CustomPagination from '../../CustomPagination/CustomPagination';
import Loader from '../../../components/Common/Loader';
import StarRating from '../../StarRating';

import messages from '../../../locale/messages';
import debounce from '../../../helpers/debounce';
import { capitalizeFirstLetter } from '../../../helpers/capitalizeFirst';
import { demoRestrictionEncode } from '../../../actions/demoRestriction';
import { censorWord, decode } from '../../../helpers/queryEncryption';

import bt from '../../../components/commonStyle.css';
import s from './ManageRatings.css';

export class ManageRatings extends Component {
	static propTypes = {
		reviews: PropTypes.object,
	}
	constructor(props) {
		super(props)
		this.state = {
			currentPage: 1,
			isRestrict: false
		}
	}

	async componentDidMount() {
		const { demoRestrictionEncode } = this.props;
		const isRestrict = await demoRestrictionEncode({});
		this.setState({ isRestrict });
	}

	handleKeywordSearch = debounce((searchList) => {
		const { reviews: { refetch } } = this.props
		let variables = {
			currentPage: 1,
			searchList
		}
		this.setState(variables)
		refetch(variables)
	}, 250);

	paginationData = (currentPage) => {
		const { reviews: { refetch } } = this.props;
		let variables = { currentPage };
		this.setState({ currentPage });
		refetch(variables);
	}

	render() {
		const { reviews, reviews: { getReviews, loading } } = this.props;
		const { currentPage, isRestrict } = this.state;
		const { formatMessage } = this.props.intl;
		return (
			<div>
				<div className={cx(s.searchInput, 'searchInputRTL')}>
					<FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(e) => this.handleKeywordSearch(e.target && e.target.value)} className={bt.formControlInput} />
				</div>
				{
					loading && <div>
						<Loader type="circle" />
					</div>
				}
				{!loading &&
					<div className={cx('tableOuterContainer', bt.spaceTop4)}>
						<Table className="tableContainer">
							<thead>
								<tr>
									<th scope="col"><FormattedMessage {...messages.id} /></th>
									<th scope="col"><FormattedMessage {...messages.user} /></th>
									<th scope="col"><FormattedMessage {...messages.partner} /></th>
								</tr>
							</thead>
							<tbody>
								{
									reviews?.getReviews?.results && reviews?.getReviews?.results?.length > 0 && reviews?.getReviews?.results?.map((item, index) => {
										let authorId, ratings, userRating, partnerRating;
										authorId = item.authorId.split(",");
										ratings = item.ratings.split(",");

										if (authorId && authorId.length > 1) {
											if (authorId[0] === (item.bookingDetails && item.bookingDetails.partnerDetails && item.bookingDetails.partnerDetails.userId)) {
												userRating = parseFloat(ratings[0]);
											} else {
												userRating = parseFloat(ratings[1]);
											}

											if (authorId[1] === (item.bookingDetails && item.bookingDetails.userDetails && item.bookingDetails.userDetails.userId)) {
												partnerRating = parseFloat(ratings[1]);
											} else {
												partnerRating = parseFloat(ratings[0]);
											}
										} else {
											userRating = (authorId[0] === (item.bookingDetails && item.bookingDetails.partnerDetails && item.bookingDetails.partnerDetails.userId)) ? parseFloat(ratings[0]) : 0;
											partnerRating = (authorId[0] === (item.bookingDetails && item.bookingDetails.userDetails && item.bookingDetails.userDetails.userId)) ? parseFloat(ratings[0]) : 0;
										}

										if (item.bookingDetails && item.bookingDetails.userDetails && item.bookingDetails.partnerDetails) {
											return (
												<tr key={index}>
													<td data-label={formatMessage(messages.id)}>{item.bookingId}</td>
													<td data-label={formatMessage(messages.user)}>
														<div className={s.disFlex}>
															<span>{item.bookingDetails && item.bookingDetails.userDetails ? capitalizeFirstLetter(isRestrict ? censorWord(decode(item.bookingDetails.userDetails.encryptFirstName)) : decode(item.bookingDetails.userDetails.encryptFirstName)) : ''}</span>
															<span><StarRating value={userRating} name={'review'} className="manageRatingContainer" /></span>
														</div>
													</td>
													<td data-label={formatMessage(messages.partner)}>
														<div className={s.disFlex}>
															<span>{item.bookingDetails && item.bookingDetails.partnerDetails ? capitalizeFirstLetter(isRestrict ? censorWord(decode(item.bookingDetails.partnerDetails.encryptFirstName)) : decode(item.bookingDetails.partnerDetails.encryptFirstName)) : ''}</span>
															<span><StarRating value={partnerRating} name={'review'} className="manageRatingContainer" /></span>
														</div>
													</td>
												</tr>
											)
										}
									})
								}
								{
									!loading && reviews?.getReviews?.results && reviews?.getReviews?.results?.length == 0 && (
										<tr>
											<td colspan="12" className={'tableNoRecordCel'}><FormattedMessage {...messages.noResult} /></td>
										</tr>
									)
								}
							</tbody>
						</Table>
					</div>
				}
				{
					reviews?.getReviews?.results && reviews?.getReviews?.results?.length > 0
					&& <div className={cx(bt.space5, bt.spaceTop5)}>
						<CustomPagination
							total={reviews?.getReviews?.count}
							currentPage={currentPage}
							defaultCurrent={1}
							defaultPageSize={10}
							change={this.paginationData}
							paginationLabel={formatMessage(messages.ratings)}
						/>
					</div>
				}
			</div>
		)
	}
}


const mapState = state => ({});

const mapDispatch = {
	demoRestrictionEncode
};

export default compose(injectIntl,
	withStyles(bt, s),
)(connect(mapState, mapDispatch)(ManageRatings));
